import React, {useContext, useEffect, useState} from 'react';
import {AccountContext} from '../context/Accounts';
import Login from "../pages/Login";
import SignupFront from "./SignupFront";
import logo from "../assets/img/blockhivelogo2.png";
import waves from "../assets/img/Waves.gif";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Signup from "../pages/Signup";

export default (props) => {

  const [status, setStatus] = useState(true);
  const {getSession} = useContext(AccountContext);

  useEffect(() => {
    // TEMPORARY: Bypass authentication for local development
    setStatus(true);

    // Uncomment below to re-enable authentication
    /*
    getSession()
      .then(session => {
        console.log('InternalWrapper Session: ', session);
        setStatus(true);
      })
      .catch(() => {
        console.log('user not logged in')
        setStatus(false);
      })
    */
  }, []);

  return (
    <div>
      {status
        ?
        <div className={"internal-wrapper"}>
          {props.children}
        </div>
        :
        <Router>
          <Switch>
            <Route exact path="/signup" component={Signup}/>
            <Route path="/">
              <img src={logo} alt="Blockhive Technology Logo"/>
              <img src={waves} width={400} height={200} alt="Blockhive Technology Waves"/>
              <div>Not logged in.</div>
              <Login/>
              <SignupFront/>
            </Route>
          </Switch>
        </Router>
      }
    </div>
  )
}
